export interface AppConfig {
  homeURL: string;
  portalURL: string;
}

export interface ConfigDetails {
  configValue: string;
}

export interface ConfigDetailsWithKey {
  configKey: string;
  configValue: string;
}

